export const PlaceholderImage = () => {
  return (
    <div className="flex h-full w-full items-center justify-center rounded-[40px] bg-gray-200">
      <p className="text-gray-500">No Image Available</p>
    </div>
  );
};
